/** 图注与底部日期标签的目标间距 */
export const LEGEND_DATE_GAP = 20;

function buildLegendData(
  visibleSeries: IRecord[],
  legendData?: Array<IRecord | string>,
): Array<IRecord | string> {
  if (Array.isArray(legendData) && legendData.length > 0) {
    return legendData;
  }

  return visibleSeries
    .map(item => item?.name)
    .filter(Boolean)
    .map(name => ({ name: String(name) }));
}

/**
 * 单条折线也展示底部图注。
 * containLabel=true 时日期标签由 ECharts 自动占位，grid.bottom 只保留与图注的 20px 间距。
 */
export function ensureOpinionLineChartLegend({
  baseOption,
  visibleSeries,
}: {
  baseOption?: IRecord | null;
  visibleSeries: IRecord[];
}): { legend: IRecord; gridBottom: number } {
  const existingLegend = baseOption?.legend || {};
  const legendData = buildLegendData(visibleSeries, existingLegend.data);
  const shouldShowLegend = legendData.length > 0;

  return {
    legend: {
      ...existingLegend,
      show: shouldShowLegend,
      data: legendData,
      bottom: shouldShowLegend ? 0 : existingLegend.bottom,
      padding: shouldShowLegend ? [0, 0, 0, 0] : existingLegend.padding,
    },
    gridBottom: shouldShowLegend ? LEGEND_DATE_GAP : 30,
  };
}
